module.exports = __webpack_public_path__ + "media/pro/rectangle-left-fd07a910.svg";